import { combineReducers } from 'redux';

const defaultProductGroups = [];
const productGroups = (state = defaultProductGroups, action) => {
  switch (action.type) {
    case 'PRODUCT_GROUP_LIST':
      return [...action.productGroups];
    default:
      return state;
  }
};

const defaultOneTimeCharge = [];
const oneTimeCharge = (state = defaultOneTimeCharge, action) => {
  switch (action.type) {
    case 'OTC_GROUP_LIST':
      return [...action.oneTimeCharge];
    default:
      return state;
  }
};

const otc_template = (state = [], action) => {
  switch (action.type) {
    case 'OTC_TEMPLATE':
      return action.otc_template;
    default:
      return state;
  }
};

const defaultInstallationCharge = [];
const installation = (state = defaultInstallationCharge, action) => {
  switch (action.type) {
    case 'INSTALLATION_GROUP_LIST':
      return [...action.installationGroups];
    default:
      return state;
  }
};

const defaultProductGroupTemplate = [];
const productGroupTemplate = (state = defaultProductGroupTemplate, action) => {
  switch (action.type) {
    case 'GET_PRODUCT_GROUP_TEMPLATE_SUCCESS':
      return [...action.templates];
    default:
      return state;
  }
};

const defaultOneTimeChargeTemplate = [];
const oneTimeChargeTemplate = (state = defaultOneTimeChargeTemplate, action) => {
  switch (action.type) {
    case 'GET_ONE_TIME_CHARGE_TEMPLATES_SUCCESS':
      return [...action.templates];
    default:
      return state;
  }
};

export default combineReducers({
  productGroups,
  oneTimeCharge,
  otc_template,
  installation,
  productGroupTemplate,
  oneTimeChargeTemplate,
});
